import React from 'react';

import { fields, schema } from './schema';
import RecordForm from '../RecordForm';
import { RECORD_TYPES } from '../schema';

const StationRecord = ({ onPressNext, onPressPrev }) => {
  return (
    <RecordForm
      fields={fields}
      recordType={RECORD_TYPES.STATION}
      onPressPrev={onPressPrev}
      onPressNext={onPressNext}
      schema={schema}
    />
  );
};

export default StationRecord;
